
import { TableConfig, DataTable } from "@app/interfaces";

export class FormListTableConfig implements DataTable {

    constructor() { }

    static configure(): TableConfig {

        const tableConfig: TableConfig = {
            key: 'items',
            searchPanel: true,
            groupPanel: true,
            expandGroup: true,
            showPagination: {
                showPageSizeSelector: true,
                pageSize: 10,
                allowedPageSizes: [10, 25, 50, 100]
            },
            fields: [
                {
                    caption: 'Name',
                    dataField: 'name'
                },
                {
                    caption: 'Survey',
                    dataField: 'survey.name',
                    allowGrouping: true,
                    groupIndex: 1
                },
                {
                    caption: 'Action',
                    width: 80,
                    cellTemplate: {
                        id: 'itemsActionButtons',
                        buttons: [{
                            icon: 'fa fa-pencil',
                            name: "Edit",
                            eventName: "edit"
                        }, {
                            icon: 'fa fa-trash',
                            name: "Delete",
                            eventName: "delete",
                            cssClass: "bg-danger"
                        }],
                    },
                },
            ]
        };

        return tableConfig;

    }

}